<script lang="ts">
  import AuthorsInfo from '#entities/components/layouts/authors_info.svelte'
  import Ebooks from '#entities/components/layouts/ebooks.svelte'
  import EntityTitle from '#entities/components/layouts/entity_title.svelte'
  import Infobox from '#entities/components/layouts/infobox.svelte'
  import Summary from '#entities/components/layouts/summary.svelte'
  import { authorRoleProperties } from '#entities/lib/editor/properties_per_subtype'
  import type { SerializedEntity } from '#entities/lib/entities'

  const {
    entity,
    shortlistOnly,
    hasLinkTitle = false,
  }: {
    entity: SerializedEntity
    shortlistOnly?: boolean
    hasLinkTitle?: boolean
  } = $props()

  const claims = $derived(entity.claims)
</script>

<EntityTitle
  {entity}
  {hasLinkTitle}
/>
<AuthorsInfo {claims} />
<Infobox
  {claims}
  entityType={entity.type}
  omittedProperties={authorRoleProperties}
  {shortlistOnly}
/>
<Ebooks {entity} />
<Summary {entity} />
